export enum DisciplinaryMeasuresTypes  {
    Article = 1,
    Suspension = 2,
    Advertence = 3
}